import ExchangeComponent from "@/app/components/exchange/exchange-component.vue";

export interface InvolvedParty {
  id: string;
  contactId: string;
  roleId: string;
  contactType: "USER" | "ORGANISATION" | "ORGANISATIONS_WITH_ROLE" | "USERS_WITH_ROLE" | "ALL";
  partyRoleId?: string //roleid for user/org. as this is seperate from the roleId of the party system
}

export interface ExchangeStep {
  id: string;
  stepId: string; // this id is the dataverse id, not the id used by us.
  state: "INPROGRESS" | "COMPLETED" | "SKIPPED" | "TODO";
  data: any;
  lastModifiedOn: string;
}

export interface Exchange {
  id: string;
  exchangeDefinitionId: string;
  currentStep: string;
  state: "INPROGRESS" | "COMPLETED" | "CANCELED";
  createdOn: string;
  createdBy: string;
  lastModifiedOn: string;
  lastModifiedBy: string;
  involvedParties: InvolvedParty[];
  steps: ExchangeStep[];
}

export class ExchangeControl {
  private exchangeComponent: ExchangeComponent;
  constructor(exchangeComponent: ExchangeComponent) {
    this.exchangeComponent = exchangeComponent;
  }

  public setStepPosition(stepId: string) {
    if (this.exchangeComponent) {
      this.exchangeComponent.setState(stepId);
    }
  }
}

export interface ExchangeEvent {
  action: "SUBMIT" | "CLOSE" | "UPDATESTEP" | "VIEWNEXT";
  metadata: { [key: string]: any };
}
